import { Avatar, Button, Divider, Dropdown, List, Menu, message, Modal, Radio, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { Activity, CheckCircle, ClipboardList, ClipboardPen, LogOut, NotebookPen, Plus, Send, User2 } from 'lucide-react';
import NewEnquiry from '../../pages/adminModule/newEnquiry/NewEnquiry';
import { fetchCurrentProfile } from '../../service/api';
import { useState } from 'react';
import '../../style/page.css'


function ProfileMenu({ setIsLoading }) {
    const navigate = useNavigate()
    const { logout, loggedUser, user, setToken, getIsLoggedUser, getCurrentUser, logoutAllDaycare } = useAuth()
    const [open, setOpen] = useState(false);

    const handleLogout = () => {
        logout(user?.daycareId)
        setOpen(false)
    }

    const updateTokenStorage = (newToken) => {
        const hasLocal = localStorage.getItem("token");
        const hasSession = sessionStorage.getItem("token");

        if (hasLocal) {
            localStorage.setItem("token", newToken);
        }

        if (hasSession) {
            sessionStorage.setItem("token", newToken);
        }

        // fallback (first login case)
        if (!hasLocal && !hasSession) {
            localStorage.setItem("token", newToken);
        }
    };

    const handleLogoutPopup = () => {
        const multipleDaycare = loggedUser?.length > 1;

        Modal.confirm({
            title: 'Logout',
            content: multipleDaycare
                ? 'Do you want to logout this daycare or all daycare accounts?'
                : 'Are you sure you want to logout?',
            okText: multipleDaycare ? 'Logout This' : 'Logout',
            cancelText: 'Cancel',

            onOk() {
                logout(user?.daycareId);
                setOpen(false);
            },

            ...(multipleDaycare && {
                footer: (_, { OkBtn, CancelBtn }) => (
                    <Space>
                        <Button
                            danger
                            onClick={() => {
                                logoutAllDaycare();
                                setOpen(false);
                                Modal.destroyAll();
                            }}
                        >
                            Logout All
                        </Button>
                        <OkBtn />
                        <CancelBtn />
                    </Space>
                ),
            }),
        });
    };

    const menu = (
        <Menu
            className="custom-profile-dropdown profile_list"
            items={[
                {
                    key: '1',
                    disabled: true,
                    label: (
                        <>
                            <h4>My Account </h4>
                            <List
                                itemLayout="horizontal"
                                dataSource={loggedUser}
                                renderItem={(item, index) => (
                                    <List.Item
                                        style={{
                                            cursor: item.isLogged ? "not-allowed" : "pointer",

                                        }}
                                        onClick={() => {
                                            if (!item.isLogged) {
                                                console.log("!item.isLogged", !item.isLogged)
                                                getIsLoggedUser({ ...item })
                                                setToken(item.token)
                                                updateTokenStorage(item.token)
                                                setOpen(false

                                                )
                                            }
                                        }}
                                        extra={item.isLogged && <CheckCircle size={20} color='#6BC445' />}>
                                        <List.Item.Meta
                                            avatar={<Avatar src={item.daycareProfile} icon={<User2 size={20} />} />}
                                            title={<h4>{item.daycareName}</h4>}
                                            description={item.daycareLocation}
                                        />
                                    </List.Item>
                                )}
                            />
                            <Divider style={{ margin: "8px 0" }} />
                        </>
                    ),
                },
                {
                    key: '3',
                    label: (
                        <p onClick={() => navigate('profile')}><User2 size={14} /> View Profile</p>
                    ),
                },
                {
                    key: '4',
                    label: (
                        <p onClick={() => navigate('aboutus')}><ClipboardList size={14} /> About us</p>
                    ),
                },
                {
                    key: '5',
                    label: (
                        <p onClick={() => navigate('privacy-policy')}><ClipboardPen size={14} /> Privacy Policy</p>
                    ),
                },
                {
                    key: '6',
                    label: (
                        <p onClick={() => navigate('term-condition')}><NotebookPen size={14} /> Terms & Conditions</p>
                    ),
                },
                {
                    key: '7',
                    label: (
                        <center>
                            <Space>
                                <NewEnquiry />
                                <Button block onClick={handleLogoutPopup} danger icon={<LogOut size={16} />}>Logout</Button>
                            </Space>
                        </center>
                    ),
                },

            ]}
        />
    );


    return (
        <Space direction="vertical">
            <Dropdown
                open={open}
                onOpenChange={setOpen}
                overlay={menu} placement="bottomRight" trigger={['click']}>
                <Space style={{ cursor: "pointer" }}>
                    <h3> Welcome, {user?.daycareName}  </h3>
                    {user?.daycareProfile ?
                        <Avatar size={36} src={user?.daycareProfile} />
                        : <Avatar size={36} icon={<User2 size={20} />} />}
                </Space>
            </Dropdown>
        </Space>
    )
}



export default ProfileMenu